module.exports = {"component":"date-picker","status":"prod","display-name":"Datepickers","last-accessibility-review":{"date-iso-8601":"2017/01/20","commit-sha":"568f503b19ddc039207e4b5c2636461de937f5f0"},"SLDS-component-path":"/components/datepickers","url-slug":"date-pickers"}


//////////////////
// WEBPACK FOOTER
// ./components/date-picker/docs.json
// module id = 267
// module chunks = 0